import { format, parse } from 'date-fns';
import React from 'react'
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

const LargeWeekViewAvailabilityPlaceholderChip = ({event}) => {

  return (
    <li key={event.id} className={classNames(`relative cursor-pointer flex transition-width duration-300  w-1/${event.column} col-start-${event.index} -z-50`)} style={{ gridRow: `${event.rowNumber}/ ${event.rowNumber + event.rowLength}`}}>
      <div
        className={classNames(
          (event.isAvailabilityPlaceholder || event.isPendingOffer) && `border-solid opacity-60 border-2 ${event.color.borderColor200}`, 
          event.isPendingOffer && 'bg-gray-200 border-black text-white',
          !event.isAvailabilityPlaceholder && !event.isPendingOffer && `${event.color.bgColor200}` ,`group absolute inset-x-1 inset-y-0 inset flex flex-col overflow-y-auto rounded-lg px-1 text-xs transition-shadow duration-300 border-solid border-2 ${event.color.borderColor500} leading-5 hover:${event.color.textColor800}`)}
      >
        {event.isPendingOffer && <p className='m-0 text-red-600 text-xs border-2 border-red-600 border-solid text-center rounded-md'>PENDING OFFER</p>}
        <p className={`font-bold text-sm m-1 p-0 text-left ${event.color.textColor800}`}>{event.name}</p>
        <p className={`${event.color.textColor500} m-0 inline-block -mt-2 p-0 ml-1 text-[10px] w-1/2 text-left`}>
          <time dateTime={event.dateTime}>{format(parse(event.time, 'H:mm', new Date()), 'h:mm a')}</time>
        </p>
        {!event.isAvailabilityPlaceholder && <p className={`inline-block text-[10px] w-1/2 ml-12 -mt-5 ${event.color.textColor500} text-center m-0`}>{event.lessonLength} min</p>}
      </div>
    </li>
)
}
export default LargeWeekViewAvailabilityPlaceholderChip;
